<div class="modal-container" [style.--icon-size]="data.titleLocalizationKey ? '50px' : '128px'">
    <div class="modal__header" *ngIf="data.titleLocalizationKey">
        <mat-icon
            *ngIf="data.titleIcon != 'DEFAULT'"
            [class]="'modal__icon--' + data.titleIcon"
            [svgIcon]="data.titleIcon"
        ></mat-icon>
        <span class="modal__title">
            {{ data.titleLocalizationKey | i18next }}
        </span>
    </div>
    <div class="modal__body">
        <div class="modal-content">
            <div class="modal-content__icon" *ngIf="data.content.icon">
                <mat-icon [svgIcon]="data.content.icon"></mat-icon>
            </div>
            <div *ngFor="let text of data.content.text">
                <p class="modal-content__text">
                    <span
                        *ngIf="(text | i18next) != 'undefined'"
                        class="d-block"
                        [innerHtml]="text | i18next | markdownBold"
                    >
                    </span>

                    <span
                        *ngIf="(text | i18next) == 'undefined'"
                        style="white-space: pre-line"
                        class="d-block bold"
                        [innerHtml]="text | i18next | markdownBold"
                    ></span>
                </p>
            </div>
            <div
                *ngIf="data.content.descriptiveText != null"
                [innerHTML]="data.content.descriptiveText | i18next"
            ></div>
            <div class="modal-content__button" *ngIf="data.content.button != null">
                <button aum-button autofocus #btn color="accent">
                    {{ data.content.button | i18next }}
                </button>
            </div>
            <div class="modal-content__text-below-button" *ngIf="data.content.textBelowButton != null">
                {{ data.content.textBelowButton | i18next }}
            </div>
            <ng-content></ng-content>
        </div>
    </div>
    <div class="modal__footer" *ngIf="data.footerButtons != null && data.footerButtons.length > 0">
        <button
            *ngFor="let footerButton of data.footerButtons"
            aum-button
            autofocus
            #btn
            [disabled]="footerButton.disabled"
            color="{{ footerButton.buttonColor }}"
            (click)="onAction(footerButton.action)"
        >
            {{ footerButton.localizationKey | i18next }}
        </button>
    </div>
    <button class="modal__close" mat-icon-button *ngIf="data.showCloseButton" (click)="onClose()" type="button">
        <mat-icon>close</mat-icon>
    </button>
</div>
